import { render, staticRenderFns } from "./Payroll-Header.vue?vue&type=template&id=fdf8b590&"
import script from "./Payroll-Header.vue?vue&type=script&lang=js&"
export * from "./Payroll-Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports